module.exports = __webpack_public_path__ + "img/cancel-reason-logo.aab6c881.png";